module.exports = __webpack_public_path__ + "img/img-03.6a8cc6d5.jpg";